<template>
  <div class="gw1021-container">
    <div class="sensor-view">
      <gwSensorView :sensorList="sensorList" :realDataObj="realDataObj" />
    </div>

    <div class="map-view">
      <bmapView style="height: 500px" :res="realDataObj" />
    </div>
  </div>
</template>
<script>
import bmapView from './components/BMapGL/index.vue';
import gwSensorView from '@/components/gwSensor/index.vue';
import { toBmapPos2 } from '@/utils/bmapUtil';

import { isEmpty } from '@/utils/is';

export default {
  name: 'GW1021-device',
  computed: {
    sn() {
      return this.$attrs.sn || this.$route.params.sn;
    }
  },
  components: {
    gwSensorView,
    bmapView
  },
  sockets: {
    '/socket/basic'(res) {
      if (res.sn !== this.sn) return;
      if (isEmpty(res)) return;
      let positionArr = toBmapPos2({ coordinate: [res.longitude, res.latitude] });
      Object.assign(this.realDataObj, res);
      this.realDataObj.longitude = positionArr[0];
      this.realDataObj.latitude = positionArr[1];
    }
  },

  data() {
    return {
      disableNotice: true,
      sensorList: [
        {
          name: '中子剂量率信息',
          prop: 'neutronValue',
          unitName: 'nSv/h'
        },
        {
          name: '检测时间',
          prop: 'testTime'
        }
      ],
      realDataObj: {
        testTime: '-',
        neutronValue: '-',
        longitude: 0,
        latitude: 0
      }
    };
  },
  mounted() {},

  methods: {}
};
</script>

<style lang="scss">
.gw1021-container {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  gap: 20px;
  .map-view,
  .sensor-view {
    width: 50%;
  }

  .sensor-view {
    .el-row {
      margin-bottom: 10px;
      .grid-content {
        height: 150px;
        border: 1px solid rgb(96, 118, 173);
        margin-bottom: 20px;
        .sensor-info {
          //   text-align: center;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          .name,
          .unit {
            font-size: 18px;
          }
          .value {
            color: #00e401;
            font-size: 22px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
